import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackAlignItems, StackType, StackWidth, TextAlignTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from "./types";
import { goToInit, onChangeDimension } from "./actions";
import { isMobile } from "../../configs/utils";
const _isMobile = isMobile();
export const template = async () => ({
    layout: {
        id: ROUTE.CHECK_LIMIT_NO_MF,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'CheckLimitNoMFRootParentStack', type: WIDGET.STACK },
        ],
    },
    datastore: {
        CheckLimitNoMFRootParentStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitNoMFRootStack', type: WIDGET.STACK },
            ]
        },
        CheckLimitNoMFRootStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            maxWidth: 412,
            padding: {
                all: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL
            },
            widgetItems: [
                { id: 'CheckLimitNoMFRootStackImage1', type: WIDGET.IMAGE },
                { id: 'CheckLimitNoMFRootStackSpace0', type: WIDGET.SPACE },
                { id: 'CheckLimitNoMFRootStackT1', type: WIDGET.TEXT },
                { id: 'CheckLimitNoMFRootStackSpace1', type: WIDGET.SPACE },
                { id: 'CheckLimitNoMFRootStackT2', type: WIDGET.TEXT },
                { id: 'CheckLimitNoMFRootStackSpace2', type: WIDGET.SPACE },
                { id: 'EditDetail', type: WIDGET.BUTTON },
            ],
            dimensionAction: {
                routeId: ROUTE.CHECK_LIMIT_NO_MF,
                type: ACTION.ON_CHANGE_DIMENSION,
                payload: {}
            }
        },
        EditDetail: {
            fontSize: FontSizeTokens.MD,
            label: "Edit details",
            fontFamily: FontFamilyTokens.Poppins,
            type: ButtonTypeTokens.LargeFilled,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.GO_TO_INIT,
                payload: {},
                routeId: ROUTE.CHECK_LIMIT_NO_MF,
            },
        },
        CheckLimitNoMFRootStackT1: {
            label: "No investment found",
            fontSize: _isMobile ?
                FontSizeTokens.MD :
                FontSizeTokens.LG,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: "600",
            textAlign: TextAlignTokens.center,
            lineHeight: 24
        },
        CheckLimitNoMFRootStackT2: {
            label: "Try with another mobile or PAN",
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Grey_Charcoal,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: "500",
            textAlign: TextAlignTokens.center,
            lineHeight: 18
        },
        CheckLimitNoMFRootStackImage1: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/no_investment_1.png',
            width: _isMobile ? 124 : 140,
            height: _isMobile ? 124 : 140,
        },
        CheckLimitNoMFRootStackSpace0: {
            size: _isMobile ? SizeTypeTokens.XXXL : SizeTypeTokens.Size32
        },
        CheckLimitNoMFRootStackSpace1: {
            size: _isMobile ?
                SizeTypeTokens.SM :
                SizeTypeTokens.MD
        },
        CheckLimitNoMFRootStackSpace2: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.Size32
        },
    }
});
export const CheckLimitNoMF = {
    onLoad: async () => {
        return Promise.resolve(template());
    },
    actions: {
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.GO_TO_INIT]: goToInit
    },
};
